import type { Language } from '@seek/melways-sites';
import { format, parseISO } from 'date-fns';
// @ts-ignore
import writtenNumber from 'written-number';

import translations from './date.vocab';

function getMessageSync(lang: Language) {
  const messages = translations.getLoadedMessages(lang);
  if (!messages) {
    translations.load(lang);
    return null;
  }
  return messages;
}

export const getScreenReaderDate = (
  date: string,
  language: Language = 'en',
) => {
  try {
    const isoDate = parseISO(date);
    const day = writtenNumber(format(isoDate, 'd'));
    const month = format(isoDate, 'MMMM');
    const year = writtenNumber(format(isoDate, 'yyyy'));
    return `${day} ${month}, ${year}`;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return getMessageSync(language)?.['Invalid date'].format();
  }
};
